import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Table, Button, Switch, Spin, message } from 'antd';
import axios from 'services/axios_config';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';

import background_circle_green from 'images/background_circle_green.svg';
import icon_in_green_circle from 'images/icon_in_green_circle.svg';
import { getDataHeaderRowSet } from 'services/home';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import HeaderHome from 'components/header/HeaderHome';
import Column from './Upload/Columns';
import LimitedColumns from './Upload/LimitedColumns';
import FinalPreview from './Upload/FinalPreview';
import Loader from 'components/Loader';

const key = 'updatable';

const HeaderRowSetView = () => {
    let navigate = useNavigate();

    const { id } = useParams();

    const [csvFile, setCsvFile] = useState(false);
    const [columnWarning, setColumnWarning] = useState(false);
    const [tableRender, setTableRender] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tableColumn, setTableColumn] = useState([]);

    const [headerValue, setHeaderValue] = useState(0);
    const [headerInputValue, setHeaderInputValue] = useState(0);
    const [rowValue, setRowValue] = useState(0);
    const [rangeOfColumn, setRangeOfColumn] = useState(null);
    const [descriptionValue, setDescriptionValue] = useState(false);

    const [finalPreviewVisible, setFinalPreviewVisible] = useState(false);
    const [finalPreviewRawData, setFinalPreviewRawData] = useState();

    const [columnsFinalPreview, setColumnsFinalPreview] = useState();
    const [dataFinalPreview, setDataFinalPreview] = useState(0);

    const [dotOrComma, setDotOrComma] = useState(1)    
    // const [checkedDot, setCheckedDot] = useState(false)    
    // const [checkedComma, setCheckedComma] = useState(false)



    const handleHeaderChange = (checked) => {
        let header = 1 ? checked : 0;
        setHeaderValue(header);
    };

    const handleChangeRowInput = (e) => {
        setRowValue(Number(e.target.value));
    };

    const handleChangeHeaderInput = (e) => {
        setHeaderInputValue(Number(e.target.value));
    };

    const handleRangeOfColumn = (e) => {
        setRangeOfColumn(e.target.value);
    };

    const sendData = async () => {
        let sendDataObj;

        let decimal_separator_value;

        // if(dotOrComma == 1) {
            if(dotOrComma == 1){
                decimal_separator_value = '.'
            } else {
                decimal_separator_value = ','
            }
        // }

        if (rangeOfColumn != null) {
            sendDataObj = {
                header: headerInputValue,
                first_row: rowValue,
                col_ranges: rangeOfColumn
            };
        } else {
            if(dotOrComma == 1 || dotOrComma == 2) {
                sendDataObj = {
                    header: headerValue == 0 ? 0 : headerInputValue,
                    first_row: rowValue,
                    description: descriptionValue,
                    decimal_separator: decimal_separator_value
                };
            } else{
                sendDataObj = {
                    header: headerValue == 0 ? 0 : headerInputValue,
                    first_row: rowValue,
                    description: descriptionValue,
                };
            }
            
        }

        let result = await axios
            .patch(`/api/v1/file/${id}/set-file-first-row-header/`, sendDataObj)
            .then((res) => {
                if (res.status == 200) {
                    setFinalPreviewVisible(true);
                    let dataRows = res.data.preview_after_settings.data;
                    let dataColumns =
                        res.data.preview_after_settings.schema.fields;
                    let columns = [];
                    for (let i in dataColumns) {
                        columns.push({
                            title: dataColumns[i].name,
                            width: 'auto',
                            dataIndex: dataColumns[i].name,
                            key: dataColumns[i].name
                        });
                    }

                    setColumnsFinalPreview(columns);
                    setDataFinalPreview(dataRows);
                }
            });
    };
    let handleGetHeaderRow = () => {
        getDataHeaderRowSet(id)
            .then((res) => {
                if (res.data.hasOwnProperty('data')) {
                    let dataTable = res.data?.data.data;
                    let columns = [
                        {
                            title: ``,
                            width: 'auto',
                            dataIndex: 'index',
                            key: 'index'
                        }
                    ];
                    let counter = 1;
                    for (let c in dataTable[0]) {
                        if (c !== 'index') {
                            columns.push({
                                title: `C${counter}`,
                                width: 'auto',
                                dataIndex: c,
                                key: c
                            });
                            counter += 1;
                        }
                    }

                    for (let i in dataTable) {
                        dataTable[i]['key'] = dataTable[i]['index'];
                        dataTable[i]['index'] = dataTable[i]['index'] + 1;
                    }
                    setColumnWarning(res.data.column_warning);
                    setCsvFile(res.data.decimal_separator)
                    setTableData(dataTable);
                    setTableRender(true);
                    setTableColumn(columns);
                } else if (
                    res.data.hasOwnProperty('message') &&
                    res.data.message ==
                        'File is corrupted, upload again or try with new file'
                ) {
                    setTableRender(true);
                    message.error(res.data.message);
                } else {
                    setTableData([]);
                }
            })
            .catch((err) => {
                console.log(`err`, err);
                let errCode = err.response.status;

                if (errCode == 404) {
                    let errMessage = err.response.data.message;
                    setTableRender(true);
                    message.error(errMessage);
                } else {
                    setTimeout(() => {
                        getDataHeaderRowSet(id);
                    }, 2000);
                }
            });
    };

    let getDataHeaderRowSetTimeOut = () => {
        setTimeout(function () {
            handleGetHeaderRow();
        }, 3000);
    };

    useEffect(() => {
        if (tableData.length == 0) {
            getDataHeaderRowSetTimeOut();
        }
    }, [tableData]);

    return (
        <>
            <Row>
                <Col style={{ flex: '1 1 auto' }}>
                    <HeaderHome />
                </Col>
            </Row>

            {finalPreviewVisible ? (
                <FinalPreview
                    columnsFinalPreview={columnsFinalPreview}
                    dataFinalPreview={dataFinalPreview}
                    setFinalPreviewVisible={setFinalPreviewVisible}
                    setHeaderValue={setHeaderValue}
                    setHeaderInputValue={setHeaderInputValue}
                    setRowValue={setRowValue}
                />
            ) : (
                <Row>
                    <Col span={12}>
                        <Row id="set-header-row">
                            <div
                                className="final-view-table"
                                style={{
                                    width: '100%',
                                    background: '#fff',
                                    border: '3px solid #60091D',
                                    height: 'calc(100vh - 112px)',
                                    background: '#fff'
                                }}
                            >
                                <div
                                    style={{
                                        background: '#edebe9',
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <div className="header-preview">
                                        EXCEL PREVIEW
                                    </div>
                                </div>
                                {tableRender ? (
                                    <Table
                                        columns={tableColumn}
                                        dataSource={tableData}
                                        pagination={false}
                                        scroll={true}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '43%'
                                        }}
                                    >
                                        {/* <Spin
                                            size="large"
                                            // tip="Waiting for table..."
                                        ></Spin> */}
                                        <Loader />
                                    </div>
                                )}
                            </div>
                        </Row>
                    </Col>

                    {/* {columnWarning ? (
                        <LimitedColumns
                            handleChangeHeaderInput={handleChangeHeaderInput}
                            rangeOfColum={rangeOfColumn}
                            handleHeaderChange={handleHeaderChange}
                            handleChangeRowInput={handleChangeRowInput}
                            sendData={sendData}
                            handleRangeOfColumn={handleRangeOfColumn}
                        />
                    ) : (
                        <Column
                            handleChangeHeaderInput={handleChangeHeaderInput}
                            rangeOfColum={rangeOfColumn}
                            headerValue={headerValue}
                            rowValue={rowValue}
                            headerInputValue={headerInputValue}
                            handleHeaderChange={handleHeaderChange}
                            handleChangeRowInput={handleChangeRowInput}
                            tableData={tableData}
                            sendData={sendData}
                        />
                    )} */}
                    <Column
                        handleChangeHeaderInput={handleChangeHeaderInput}
                        rangeOfColumn={rangeOfColumn}
                        setRangeOfColumn={setRangeOfColumn}
                        headerValue={headerValue}
                        setHeaderValue={setHeaderValue}
                        rowValue={rowValue}
                        headerInputValue={headerInputValue}
                        handleHeaderChange={handleHeaderChange}
                        handleChangeRowInput={handleChangeRowInput}
                        tableData={tableData}
                        tableRender={tableRender}
                        sendData={sendData}
                        columnWarning={columnWarning}
                        handleRangeOfColumn={handleRangeOfColumn}
                        setDescriptionValue={setDescriptionValue}
                        csvFile={csvFile}
                        // setCheckedComma={setCheckedComma}
                        // checkedComma={checkedComma}
                        // setCheckedDot={setCheckedDot}
                        // checkedDot={checkedDot}
                        dotOrComma={dotOrComma}
                        setDotOrComma={setDotOrComma}
                    />
                </Row>
            )}
        </>
    );
};

export default HeaderRowSetView;
